import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {
  WOStatisticsCategory,
  statisticsCategoryListParams,
} from "../../models/serverModels/workOrder/WOStatisticsCategory";

const rootApi = process.env.REACT_APP_API_KEY;

const statisticsCategory = axios.create({
  baseURL: rootApi,
});

export const getList = async (
  params: statisticsCategoryListParams
): Promise<ResponseList<WOStatisticsCategory>> =>
  statisticsCategory({
    url: "/GetStatisticsCategories",
    method: "get",
    params,
  }).then((res) => res.data);
export const getItem = async (
  params: Params.GetItem
): Promise<ResponseItem<WOStatisticsCategory>> =>
  statisticsCategory({
    url: `/statisticsCategory/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
export const create = async (
  params: Params.Create<WOStatisticsCategory>
): Promise<ResponseItem<WOStatisticsCategory>> =>
  statisticsCategory({
    url: `/statisticsCategory`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  statisticsCategory({
    url: `/statisticsCategory/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<WOStatisticsCategory>
): Promise<ResponseItem<WOStatisticsCategory>> =>
  statisticsCategory({
    url: `/statisticsCategory/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
